module.exports = __webpack_public_path__ + "media/assets/img/sidebar-2-42e96f8ddd5da9401a408f57e6b0fd6c.jpg";